import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader-title',
  templateUrl: './loader-title.component.html',
  styleUrls: ['./loader-title.component.css']
})
export class LoaderTitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/loaders/loader-title/loader-title.component.ts